var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMarker = function SvgIconMarker(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166672 6.49935C0.166672 3.27435 2.77501 0.666016 6.00001 0.666016C9.22501 0.666016 11.8333 3.27435 11.8333 6.49935C11.8333 10.8743 6.00001 17.3327 6.00001 17.3327C6.00001 17.3327 0.166672 10.8743 0.166672 6.49935ZM8.08334 6.49935C8.08334 7.64994 7.1506 8.58268 6.00001 8.58268C4.84941 8.58268 3.91667 7.64994 3.91667 6.49935C3.91667 5.34876 4.84941 4.41602 6.00001 4.41602C7.1506 4.41602 8.08334 5.34876 8.08334 6.49935Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_marker.312c8cb3.svg";
export { ForwardRef as ReactComponent };